<template>
  <li>
    <RouterLink
      v-if="routeName"
      :to="{ name: routeName }"
      class="sidebar-navigation--nav-link antialiased"
    >
      <Icon :icon="icon" />

      <span>{{ label }}</span>
    </RouterLink>

    <button
      v-else
      class="sidebar-navigation--nav-link antialiased"
      type="button"
      @click="$emit('click')"
    >
      <Icon :icon="icon" />

      <span>{{ label }}</span>
    </button>
  </li>
</template>

<script lang="ts" setup>
import Icon from "@/components/generic/Icon/Icon.component.vue";
import { IconName, RouteName } from "@/types";

interface Props {
  routeName?: RouteName;
  icon: IconName;
  label: string;
}

defineProps<Props>();
defineEmits(["click"]);
</script>
